import requests from "./httpService";

const TripadvanceApprovalServices = {
  billapprovalList: async (body) => {
    return requests.post(
      `/tripAdvance/approval-list`,
      body
    );
  },

  checkoutstanding: async (vendor_id) => {
    // console.log(vendor_id,"vendor_id")
    return requests.get(`/tripAdvance/check-outstanding/${vendor_id}`);
  },

  adjustOutstanding: async (body) => {
    return requests.put(`/tripAdvance/adjust-outstanding`, body);
  },
};

export default TripadvanceApprovalServices;
